import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./service-percentage-scheme.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service-percentage-scheme.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";
import {
  DELETE_PERCENTAGE_SCHEME,
  GET_PERCENTAGE_SCHEME,
  UPDATE_PERCENTAGE_SCHEME
} from "./service-percentage-scheme.graphql";



@Injectable()
export class ServicePercentageSchemeEffects {
  createServicePercentageScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServicePercentageSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_PERCENTAGE_SCHEME,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServicePercentageScheme({ servicePercentageScheme: result?.data }));
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateServicePercentageScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editServicePercentageSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_PERCENTAGE_SCHEME,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServicePercentageScheme({ servicePercentageScheme: result?.data }));
              await this.notificationService.successMessage('Updated Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteServicePercentageScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServicePercentageSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_PERCENTAGE_SCHEME,
        variables: {
          percentageUniqueId: action?.percentageUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServicePercentageScheme({ id: action.id }));
              await this.notificationService.successMessage('Deleted Successfully');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceCategories$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServicePercentageSchemes),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_PERCENTAGE_SCHEME,
        fetchPolicy: 'network-only',
        variables: {
          billingUniqueId: action.billingUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching billing percentage based details'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServicePercentageSchemes({ servicePercentageSchemes: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });


  citizenGetInstitutionServicePercentageSchemes$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetInstitutionServicePercentageSchemes),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_INSTITUTION_SERVICE_PERCENTAGE_SCHEME,
        fetchPolicy: 'network-only',
        variables: {
          billingUniqueId: action.billingUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching billing percentage based details'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServicePercentageSchemes({ servicePercentageSchemes: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
